import { createRouter, createWebHashHistory } from 'vue-router';
import { aplicarTemaSalvo } from '@packages/design-system';

import App from './App.vue';
import { trackRouter } from 'vue-gtag-next';
import store from './store/store';
import { temAcessoView } from './shared/auth/temAcesso';
import credenciamentoRotas from '../src/app/checkins/credenciamento/rotas.js';

import appRotas from './app/rotas.js';
import { rotasChamado, rotasLiberadas } from './app/sol/chamado/centralChamados/rotas.js';
import feiraEmpreendedorRotas from './app/checkins/feiraempreendedor/rotas.js';
import expositoresRotas from './app/checkins/expositores/formularioExterno/rotas.js';
import guicheRotas from './app/checkins/guiche/rotas.js';
import leituraQRCodeRotas from './app/checkins/impressoras/rotasLeituraQRCode.js';

const routes = [
    {
        path: '/',
        name: 'home',
        component: App,
        redirect: { name: 'DashBoard' },
        children: [...appRotas],
    },
    credenciamentoRotas,
    // {
    // 	path: '/checkins/credenciamento',
    // 	name: 'checkins_credenciamento',
    // 	component: () => import('./app/checkins/credenciamento/Credenciamento.vue'),
    // },
    {
        path: '/login',
        name: 'login',
        component: () => import('./app/auth/Login.vue'),
    },
    {
        path: '/error',
        name: 'error',
        component: () => import('./pages/Error.vue'),
    },
    {
        path: '/notfound',
        name: 'notfound',
        component: () => import('./pages/NotFound.vue'),
    },
    {
        path: '/access',
        name: 'access',
        component: () => import('./pages/Access.vue'),
    },
    {
        path: '/compra/:id',
        name: 'compra',
        component: () => import('./app/vendas/checkoutpagamentos/TelaPagamento.vue'),
        meta: { temaFixo: 'light' },
    },
    {
        path: '/compra/espelhoPedido/:id',
        name: 'espelhoPedido',
        component: () => import('./app/vendas/checkoutpagamentos/EspelhoPedido.vue'),
        meta: { temaFixo: 'light' },
    },
    {
        path: '/compra/linkExpirado/:id',
        name: 'linkExpirado',
        component: () => import('./app/vendas/checkoutpagamentos/linkExpirado.vue'),
        meta: { temaFixo: 'light' },
    },
    // {
    //     path: '/compra/:produtoCheckoutId',
    //     name: 'compra',
    //     component: () => import('./app/vendas/checkoutpagamentos/BoletoForm.vue')
    // },
    {
        path: '/compra/linkInativo/:id',
        name: 'linkInativo',
        component: () => import('./app/vendas/checkoutpagamentos/linkInativo.vue'),
        meta: { temaFixo: 'light' },
    },
    ...rotasChamado,
    ...feiraEmpreendedorRotas,
    ...expositoresRotas,
    ...guicheRotas,
    ...leituraQRCodeRotas,
    {
        path: '/:pathMatch(.*)*',
        name: 'notFoundCatchAll',
        component: App,
        children: [
            {
                path: '',
                name: 'notFoundCatchAllPage',
                component: () => import('./pages/NotFound.vue'),
            },
        ],
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

trackRouter(router);

router.beforeEach((to, from, next) => {
    // Checkout publico (/compra/*): cliente externo nunca escolheu tema e nao tem toggle
    // disponivel (sem topbar). Fixa claro ao entrar; ao sair, restaura a preferencia do
    // usuario do portal. O pre-paint em public/index.html cobre o carregamento inicial —
    // isto cobre a navegacao client-side (SPA) entrando/saindo dessas rotas.
    if (to.meta.temaFixo) {
        document.documentElement.dataset.theme = to.meta.temaFixo;
    } else if (from.meta.temaFixo) {
        aplicarTemaSalvo();
    }

    const publicPages = [
        '/login',
        '/error',
        '/notfound',
        '/atualizarsenha',
        '/recuperarsenha',
        '/sol/chamado/centralChamados',
        ...rotasLiberadas,
        '/checkins/feiraempreendedor',
        '/checkins/feiraempreendedor/totem',
        '/checkins/expositores/inscricao',
        '/checkins/feiraempreendedor/certificado',
        '/compra/:id',
        '/compra/espelhoPedido/:id',
        '/compra/linkExpirado/:id',
        '/compra/linkInativo/:id',
        '/checkins/feiraempreendedor/expositor/inscricao',
        '/checkins/guiche/painel-tv',
        '/checkins/guiche/atendente'
    ];
    const publicRotes = [
        'CRM_Checkout_Carrinhos_Pagamento',
        'BrasilMais_Certificados',
        'compra',
        'espelhoPedido',
        'linkExpirado',
        'linkInativo',
    ];
    const authRequired = !publicPages.includes(to.path) && !publicRotes.includes(to.name);

    if (!authRequired) {
        next();
    } else {
        const loggedIn = store.getters.isAutenticado;
        if (authRequired && !loggedIn) {
            store.dispatch('tryAutoLogin');
            if (store.getters.isAutenticado) {
                if (temAcessoView(to.meta.rules, to.meta.requiredUnidade)) {
                    next();
                } else {
                    next('/access');
                }
            } else {
                next({
                    path: '/login',
                    query: {
                        redirect: to.path,
                        ...to.query,
                    },
                });
            }
        } else {
            if (temAcessoView(to.meta.rules, to.meta.requiredUnidade)) {
                next();
            } else {
                next('/access');
            }
        }
    }
});

export default router;
